import { isTokenExpired } from "../helpers/TokenHelper";
import createHttpInstance from "./http-common";

class LocationServices {
    private serviceName = '/PublicRequest';

    async GetLocationList(data: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/GetOrderPublicRequest`, data).catch((err: Error) => {
            throw err?.message;
        })
    }

    async GetOrderPublicRequestById(id: any){
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/GetOrderPublicRequestById?id=${id}`).catch((err: Error) => {
            throw err?.message;
        })
    }

    async GetRequestPickupStats(entityTypeId: any){
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/GetRequestPickupStats?entityTypeId=${entityTypeId}`).catch((err: Error) => {
            throw err?.message;
        })
    }

    async GetOrderPublicRequestExport(data: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/GetOrderPublicRequestExport`, data).catch((err: Error) => {
            throw err?.message;
        })
    }
    
}

export default new LocationServices();